// Motion + accessibility helpers.
//
// Auto-advance after a single-select pick uses 250ms by default. The button
// has a 100ms border/shadow transition (see SingleSelectList.tsx), so 250ms
// gives the selected state ~150ms of breathing room before the route swaps
// — enough for the user to register "yes, that registered" without feeling
// laggy. Below ~200ms the click feels like it was skipped; 600ms (our old
// value) was noticeably sluggish over a ~50-question quiz.
//
// Screen-reader announcements start synchronously on click (aria-pressed is
// set before the timeout), so the announcement window isn't gated by this
// delay. Returns 0 when the user prefers reduced motion.

const isReduced = (): boolean => {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

export const AUTO_ADVANCE_MS = (): number => (isReduced() ? 0 : 250);

export const PREFERS_REDUCED_MOTION = (): boolean => isReduced();
